"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasWindowLocalStorage = exports.hasChromeStorage = exports.configurationStorageFactory = void 0;
const js_client_sdk_common_1 = require("@eppo/js-client-sdk-common");
const chrome_configuration_store_1 = require("./chrome.configuration-store");
const local_storage_1 = require("./local-storage");
function configurationStorageFactory({ hasChromeStorage = false, hasWindowLocalStorage = false, persistentStore = undefined, forceMemoryOnly = false, }, { chromeStorage, windowLocalStorage, } = {}) {
    if (forceMemoryOnly) {
        return new js_client_sdk_common_1.MemoryOnlyConfigurationStore();
    }
    else if (persistentStore) {
        return new js_client_sdk_common_1.HybridConfigurationStore(new js_client_sdk_common_1.MemoryStore(), persistentStore);
    }
    else if (hasChromeStorage && chromeStorage) {
        // Chrome storage is available, use it as a fallback
        return new js_client_sdk_common_1.HybridConfigurationStore(new js_client_sdk_common_1.MemoryStore(), new chrome_configuration_store_1.ChromeStorageAsyncStore(chromeStorage));
    }
    else if (hasWindowLocalStorage && windowLocalStorage) {
        // window.localStorage is available, use it as a fallback
        return new js_client_sdk_common_1.HybridConfigurationStore(new js_client_sdk_common_1.MemoryStore(), new local_storage_1.LocalStorageBackedAsyncStore(windowLocalStorage));
    }
    // No persistence store available, use memory only
    return new js_client_sdk_common_1.MemoryOnlyConfigurationStore();
}
exports.configurationStorageFactory = configurationStorageFactory;
function hasChromeStorage() {
    return typeof chrome !== 'undefined' && !!chrome.storage;
}
exports.hasChromeStorage = hasChromeStorage;
function hasWindowLocalStorage() {
    try {
        return typeof window !== 'undefined' && !!window.localStorage;
    }
    catch (_a) {
        // Chrome throws an error if local storage is disabled and you try to access it
        return false;
    }
}
exports.hasWindowLocalStorage = hasWindowLocalStorage;
//# sourceMappingURL=configuration-factory.js.map